import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_expert-connect-184/artifacts/zgfr8qi0_Consultant.svg";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#344B71] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div 
              className="flex items-center mb-6 cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => navigate('/')}
            >
              <img src={LOGO_URL} alt="ConsultantHUB" className="h-12 w-auto brightness-0 invert" />
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Il marketplace B2B per servizi professionali. Connetti professionisti qualificati e aziende in cerca di competenze.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E8A007] rounded-full flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E8A007] rounded-full flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E8A007] rounded-full flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-6 text-lg">Link Utili</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => navigate('/faq')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  Come Funziona
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/faq')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/support')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  Centro Assistenza
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/complaints')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  Segnala un Problema
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/contatti')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  Contatti
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-6 text-lg">Privacy & Legal</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => navigate('/privacy')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/gestione-privacy')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  Gestione Cookie
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/privacy')}
                  className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors"
                >
                  Termini di Servizio
                </button>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-6 text-lg">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#E8A007] mt-0.5 flex-shrink-0" />
                <a href="mailto:supporto@consultanthub.it" className="text-slate-300 hover:text-[#E8A007] text-sm transition-colors">
                  supporto@consultanthub.it
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#E8A007] mt-0.5 flex-shrink-0" />
                <span className="text-slate-300 text-sm">
                  Italia
                </span>
              </li>
            </ul>
            
            {/* CTA Button */}
            <button 
              onClick={() => navigate('/contatti')}
              className="mt-6 inline-flex items-center bg-[#E8A007] hover:bg-[#d49506] text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors"
            >
              Contattaci
            </button>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between">
          <p className="text-slate-400 text-sm">
            © 2025 ConsultantHUB. Tutti i diritti riservati.
          </p>
          <button 
            onClick={() => navigate('/admin')}
            className="text-slate-500 hover:text-[#E8A007] text-xs mt-4 md:mt-0 transition-colors"
          >
            Area Riservata
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
